import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import { styles } from './styles';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (e: any) => any;
    children: any;
    disabled?: boolean;
    fullWidth?: boolean;
    endIcon?: any;
    ref?: any;
    className?: string;
}
const Button = (props: IProps) => {
    return (<MuiButton
        ref={props.ref}
        fullWidth={props.fullWidth}
        disabled={props.disabled}
        className={clsx(props.classes.btnRoot, props.className)}
        onClick={props.onClick}
        variant="contained" >
        {
            props.endIcon ?
                <div
                    className={props.classes.withIcon}>
                    {props.children}
                    {props.endIcon}
                </div> :
                props.children
        }
    </MuiButton >)
}


export default withStyles(styles)(Button)